export default function validateAndSanitizeTerm(input: string) {
  const sanitizedInput = encodeURIComponent(input);
  return sanitizedInput;
}
